


















































import companyType from '@/store/types/company';
import { TeipNotifications } from '@/util/teipNotifications';
import commissions from '@/components/Company/newCompany/companyInfo/forms/commissions.vue';
import {
  CompanyParams,
  EnterpriceAddress,
  EnterpriceCommissions,
  EnterpriceData
} from '@/store/interfaces/company';
import root from '@/store/types/root';
import copyObj from '@/util/copyObj';
import { IObjectKeys } from '@/store/interfaces/generic';
import enterpriseData from '@/components/Company/newCompany/companyInfo/enterpriseData.vue';
import enterpriseAddress from '@/components/Company/newCompany/companyInfo/enterpriseAddress.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { dayjsUTC } from '@/util/classes/datesFormat';

export default Vue.extend({
  name: 'ProfileCompanyUpdateCompany',
  components: {
    commissions,
    enterpriseData,
    enterpriseAddress,
  },

  data: () => ({
    loading: true,
    company: {
      id: '',
      business_name: '',
      liquidation_kind_id: '',
      membership_status: 'inactive',
      membership_validation: 'no',
      branches_count: 0,
      billing_comment: '',
      address: {
        description: '',
        phone: '',
        state_code: '',
      },
      artificial_person: false,
      company_profile_id: '',
      state_code: '',
      taxpayer_type: 'non',
      contacts: [],
      bank_account: {
        account_number: '',
        account_type: 'current',
        bank_id: '',
        id: '',
        name: '',
        billing_type: 'final_consumer',
        account_holder: '',
        billing_address: '',
        contact: {
          email: '',
          id: '',
          name: '',
          phone: '',
          phone2: '',
        },
        contact_id: '',
      },
      commission: {
        rate: 0,
        start_at: '',
        liquidation_period: '',
        minimum_order_value: 0,
        renewal: 'automatic',
      },
      commerces_count: 2,
      created_at: '2021-03-10T20:18:56Z',
      business_turn: 'company',
      company_profile: null,
      name: 'company',
      fixed_withholding: false,
      business_activity_summary: null,
    } as CompanyParams,
  }),
  computed: {
    ...mapGetters({
      getSingleCompany: `companyModule/${companyType.getters.GET_SINGLE_COMPANY}`,
      getProcess: root.getters.GET_START_PROCESS,
    }),
    modelEnterpriseAddress: {
      get() {
        const company = this.getSingleCompany;
        if (company.address) {
          return {
            state_code: company.address.state_code,
            description: company.address.description,
            phone: company.address.phone,
          };
        } else {
          return {
            state_code: '',
            description: '',
            phone: '',
          };
        }
      },
      set(model: EnterpriceAddress) {
        this.company.address = {
          ...this.company.address,
          ...model,
        };
        this.company.state_code = model.state_code;
      },
    },
    modelEnterpriseData: {
      get() {
        const company = this.getSingleCompany;
        return {
          business_name: company.business_name || '',
          artificial_person: company.artificial_person,
          membership_status: company.membership_status,
          membership_validation: company.membership_validation,
          taxpayer_type: company.taxpayer_type,
          state_code: company.state_code,
          business_turn: company.business_turn,
          liquidation_kind_id: company.liquidation_kind_id || '',
          company_profile_id: company.company_profile?.id || '',
          fixed_withholding: company.fixed_withholding || false,
          business_activity_summary: company.business_activity_summary || '',
          name: company.name,
          billing_comment: company.billing_comment || '',
        };
      },
      set(model: EnterpriceData) {
        this.company = {
          ...this.company,
          ...model,
        };
      },
    },
  },
  created() {
    this.company = copyObj(this.getSingleCompany);
    delete this.company.contacts;
    delete this.company.bank_account;
    delete this.company.id;

    // Formats date
    if (this.company.commission) {
      const start_at = this.company.commission.start_at;
      this.company.commission.start_at = dayjsUTC(start_at)
        .format('YYYY-MM-DD');
    }

    this.loading = false;
  },
  methods: {
    ...mapActions({
      updateCompany: `companyModule/${companyType.actions.UPDATE_COMPANY}`,
    }),
    getCommissions(val: EnterpriceCommissions) {
      this.company.commission = val;
    },
    updateProfile() {
      const notificacion = new TeipNotifications();
      const companyToUpdate: IObjectKeys = copyObj(this.company);

      const toUpdate = {
        data: companyToUpdate,
        company_id: this.$route.params.company_id,
      };

      this.updateCompany(toUpdate)
        .then(() => {
          notificacion.success('Actualizado correctamente');
          this.$emit('cancel', true);
        })
        .catch(() => {
          notificacion.warning('Algo ha salido mal');
        });
    },
    cancel() {
      this.$emit('cancel', true);
    },
  },
  watch: {
    'company.state_code'(val: string) {
      if (this.company.address) {
        this.company.address.state_code = val;
      }
    },
  },
});

